var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
    click: function click() {
      return _vm.$emit('click');
    }
  } : {}), [_vm._t("icon"), _c('v-list-item-content', [!_vm.small ? _c('v-list-item-subtitle', [_c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.item.hasAsset ? 'success' : 'warning',
      "elevation": 0,
      "dark": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.item.hasAsset ? _vm.$t("objects.video.asset.status.".concat(_vm.item.asset.status)) : _vm.$t("objects.video.upload.status.".concat(_vm.item.upload.status))) + " ")])], 1) : _vm._e(), _c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.id) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.id) + " ")])])], 1)], 2) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }